/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 用户相关 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 用户相关 忘记密码 */
export async function forgetPasswordPost(payload: model.IApiResetPasswordReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/auth/api/pub/user/email/forgetPassword`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 用户相关 邮箱密码登录 */
export async function emailPwdLoginPost(payload: model.IApiEmailLoginReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultLoginResp>({
    url: `/auth/api/pub/user/email/pwd/login`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 用户相关 获取用户信息 */
export async function getUserInfoGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultUserInfoResp>({
    url: `/auth/api/pub/user/info`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** 用户相关 邮箱注册 */
export async function emailSignUpPost(payload: model.IApiEmailSignupReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/auth/api/pub/user/signup/email`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** 用户相关 邮箱注册校验 */
export async function emailSignUpCheckPost(payload: model.IApiEmailSignupCheckReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultEmailSignUpCheckResp>({
    url: `/auth/api/pub/user/signup/email/check`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}
